import React from 'react'

import {DashboardReportConfig} from "../../../../../analytics/dashboard/@type"

type Props = {
    item           : DashboardReportConfig
    onSelectReport : callback
}

export default function ModalReportSelect_ReportPreviewWithSubitems(props: Props) {

    return (
        <div className  = "report-preview-card-subitems"
             style      = {{
                 width: 335
             }}
        >
            <div className="flex-row-left-top m-l-30 m-r-30 m-t-30 m-b-10">
                <div className="min-w-35">
                    <div className={Classes(props.item.icon, "w-100-percent h-35 ui5-ico-18")}/>
                </div>
                <div className="m-l-25 flex-1 min-w-0">
                    <div className="ui5-txt-default m-b-8">{props.item.name}</div>
                    <div className="ui5-txt-not-important-tiny lh-14em">{props.item.description}</div>
                </div>
            </div>
            <div className="flex-column-right-top m-b-15">
                {_.map(props.item.subitems, (subitem: DashboardReportConfig, key: number) => {
                    const isDisabled = subitem.disabled

                    const classes = Classes("subitem", {
                        "is-disabled": isDisabled
                    })

                    const iconClasses = Classes(subitem.icon, "subitem-icon ui5-ico-13 flex-no-shrink m-r-7")

                    return (
                        <div key       = {key}
                             className = {classes}
                             onClick   = {isDisabled ? undefined : () => props.onSelectReport(subitem.createReport!())}>
                            <div className="subitem-content flex-row-left-center flex-1 m-l-5 m-r-20">
                                <div className="flex-1 min-w-0 flex-row-left-center">
                                    <div className={iconClasses}/>
                                    <span className="subitem-name ui5-txt-not-important-small">{subitem.name}</span>
                                </div>

                                {!isDisabled &&
                                    <div className="subitem-arrow ui5-ico-9 i5-big-angle-right flex-no-shrink"/>
                                }
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
